import {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
  useEffect,
} from "react";
import { StyledContainer } from "./drawer.styles";

const THRESHOLD = 0.6; // 60% of the screen width

type DrawerContextType = {
  isDrawerOpen: boolean;
  toggleDrawer: () => void;
};

const DrawerContext = createContext<DrawerContextType>({} as DrawerContextType);

export const DrawerContextProvider = ({ children }: PropsWithChildren) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  useEffect(() => {
    const checkWindowSize = () => {
      if (
        (!isDrawerOpen &&
          window.innerWidth > window.screen.width * THRESHOLD) ||
        (isDrawerOpen && window.innerWidth <= window.screen.width * THRESHOLD)
      ) {
        setIsDrawerOpen((prev) => !prev);
      }
    };

    window.addEventListener("resize", checkWindowSize);

    return () => {
      window.removeEventListener("resize", checkWindowSize);
    };
  }, [isDrawerOpen]);

  return (
    <DrawerContext.Provider
      value={{
        isDrawerOpen,
        toggleDrawer: () => setIsDrawerOpen((prev) => !prev),
      }}
    >
      <StyledContainer $isDrawerOpen={isDrawerOpen}>{children}</StyledContainer>
    </DrawerContext.Provider>
  );
};

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error(
      "useDrawerContext must be used within a DrawerContextProvider",
    );
  }
  return context;
};
